import React, { useEffect, useState } from 'react';

import { useData } from '../../..';
import { Pressable, Text, View, ViewStyle } from 'react-native';

import { setVar } from '../../functions';
import { doc, updateDoc } from 'firebase/firestore';
import { unlockBike } from '../pagarme/helpers/unlockBike';
import { firestoreOutFlax } from '../../functions/firebase/firebase';
import {
  boxReturn,
  stlBorder,
  stlBtn1,
  stlBtn2,
  stlError,
  stlTag,
} from './helpers/styles';
import { LoopBtnReturn } from './helpers/LoopBtnReturn';
import { goTo } from '../../project';

type Tprops = {
  pass: {
    keyPlaces: string;
    pathInitMap: string[];
    arrPins: string[];
    arrFuncs: any[];
  };
  args?: any;
};

type Tlock = 'unlock' | 'lock';
export type Tstation = {
  ID: number;
  Name: string;
  x_coord: number;
  y_coord: number;
  racks: {
    rackID: number;
    status: Tlock;
  }[];
};

export const ReturnBikeAuto = (props: Tprops) => {
  // ---------- set Props
  const [sttReturn, setReturn] = useState(false);
  const [sttConfirm, setConfirm] = useState(false);
  const [sttError, setError] = useState(false);

  const currReturnBikeId = useData(ct => ct.sc.B5.currData.currReturnBikeId);
  const hasData = useData(ct => ct.sc.B5?.currData?.docId);

  const currRentDocId = useData(
    ct => ct?.all?.userData?.activeRentData?.rentId,
  );
  const currUserDocId = useData(ct => ct?.all?.userData?.docId);
  const arrayAutoBikes = useData(ct => ct.sc.B5.currData.bikesList); // ??? CONFIRMAR AQUI

  const localName = useData(
    ct => ct.sc.B5.currData?.selectedMapPin?.localName ?? '...',
  );
  const emptyDataMapPin = useData(ct => !!ct.sc.B5.currData?.selectedMapPin);
  const formatedAdress = useData(
    ct =>
      ct.sc.B5.currData?.selectedMapPin?.localAddress?.formatted_address ??
      '...',
  );
  const stationApiID = useData(
    ct => ct.sc.B5.currData?.selectedMapPin?.apiLocationID,
  );

  const condBikeSelected = currReturnBikeId > 0;

  const btnConfirm = () => setConfirm(true);
  const btnCancel = () => setConfirm(false);
  const btnReturn = async () => {
    if (condBikeSelected) {
      console.log('CHAMAR ASYNC');
      asyncReturnBike(stationApiID);
    } else {
      console.log('CHAMAR ERRO');
      setError(true);
    }
  };

  const asyncReturnBike = async stationApiID => {
    // --- Aqui foi feito um array p/ o caso de poder futuramente alugar + de uma bike
    const arrayBayIds = arrayAutoBikes.map(item => ({
      currId: currReturnBikeId,
      actions: 'lock' as const,
      stationApiID,
    }));

    console.log({ arrayBayIds });

    const resApiStation = await unlockBike(arrayBayIds);

    console.log({ resApiStation });

    const refColl = doc(firestoreOutFlax, 'rents', currRentDocId);

    const dataToUpdate = {
      bikeReturned: 'sim',
      [`timer.isRunning`]: 'false',
      [`timer.endTimeStamp`]: Date.now(),
    };

    await updateDoc(refColl, dataToUpdate).catch(err =>
      console.log('Erro do updateDoc', { err }),
    );

    const refColl2 = doc(firestoreOutFlax, 'users', currUserDocId);

    const dataToUpdate2 = {
      ['activeRentData.rentId']: 'null',
    };

    await updateDoc(refColl2, dataToUpdate2).catch(err =>
      console.log('Erro do updateDoc', { err }),
    );

    setVar({
      args: {},
      pass: {
        keyPath: ['ct.all.userData.activeRentData.rentId'],
        value: 'null',
      },
    });

    setConfirm(false);
    setReturn(false);

    // ---- Volta pro Mapa Principal
    goTo('b3bikemap');
  };

  // ------------------------------
  // Busca Dados pra Exibir no Mapa
  // ------------------------------
  useEffect(() => {
    const cond1 = typeof hasData === 'string' && hasData !== '';
    const cond2 = typeof stationApiID === 'string' && stationApiID !== '';
    console.log({ cond1 });
    console.log({ cond2 });
    // when mount comp
    if (cond1) {
      if (cond2) setReturn(true);
    }
  }, [hasData, stationApiID]);

  useEffect(() => {
    console.log({ emptyDataMapPin });

    if (localName === '...') setReturn(false);
  }, [localName]);

  useEffect(() => {
    // when mount comp

    // when unmount comp clean state
    return () => {
      setVar({
        args: {},
        pass: { keyPath: ['sc.B3A.currData.currLocation.data'], value: {} },
      });
      setVar({
        args: {},
        pass: { keyPath: ['sc.B5.currData'], value: {} },
      });

      setConfirm(false);
      setReturn(false);
    };
  }, []);

  console.log({ sttReturn });
  return (
    sttReturn && (
      <View style={boxReturn}>
        <Text style={{ fontWeight: 'bold' }}>{localName}</Text>
        <Text>{formatedAdress}</Text>

        <View style={{ height: 20, width: 1 }} />

        <View style={sttError ? stlError : {}}>
          <LoopBtnReturn stationApiID={stationApiID} setError={setError} />
        </View>
        {sttError ? (
          <Text style={{ color: '#b0003a', fontWeight: 'bold' }}>
            ✕ Selecione uma baia para devolução
          </Text>
        ) : (
          <></>
        )}

        <View style={{ height: 20, width: 1 }} />

        <Pressable style={stlBtn1}>
          <Text style={{ color: 'white' }}>Ver Rota</Text>
        </Pressable>

        <View style={{ height: 20, width: 1 }} />

        {sttConfirm ? (
          <>
            <View style={stlBorder}>
              <Text style={{ color: '#333', fontWeight: 'bold' }}>
                Confirma Entrega?
              </Text>
              <Text style={{ color: '#666' }}>
                Antes de confirmar a entrega, certifique-se de que a bicicleta
                está com a trava devidamente acionada.
              </Text>

              <View style={{ height: 20, width: 1 }} />
              <View style={{ flexDirection: 'row', justifyContent: 'center' }}>
                <Pressable style={stlBtn2} onPress={btnCancel}>
                  <Text style={{ color: 'rgb(124, 35, 85)' }}>Cancelar</Text>
                </Pressable>

                <View style={{ height: 20, width: 20 }} />

                <Pressable style={stlBtn1} onPress={btnReturn}>
                  <Text style={{ color: 'white' }}>Confirmar</Text>
                </Pressable>
              </View>
            </View>
          </>
        ) : (
          <View style={stlBorder}>
            <Text style={{ color: '#666' }}>
              Coloque a bicicleta na estação e clique em "Entregar bicicleta".
              Ao fazer isso, o cronômetro será pausado.
            </Text>

            <View style={{ height: 20, width: 1 }} />

            <Pressable style={stlBtn1} onPress={btnConfirm}>
              <Text style={{ color: 'white' }}>Entregar Bicicleta</Text>
            </Pressable>
          </View>
        )}
      </View>
    )
  );
};
